import "core-js/modules/es6.string.anchor";
import cn from 'classnames';
import React from 'react';
import Heading from './OutlineHeading';

var styles = require('./LinkedHeading-styles.module.css');

function LinkedHeading(_ref) {
  var h = _ref.h,
      id = _ref.id,
      className = _ref.className,
      children = _ref.children,
      title = _ref.title;
  return /*#__PURE__*/React.createElement(Heading, {
    h: h,
    id: id,
    title: title !== null && title !== void 0 ? title : children,
    className: cn(className, styles.LinkedHeading)
  }, /*#__PURE__*/React.createElement("a", {
    href: "#" + id,
    "aria-hidden": true,
    className: styles.anchor
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": true
  }, "#")), children);
}

export default LinkedHeading;